var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{class:[ _vm.data.class, _vm.data.staticClass ],attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"href":_vm.props.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }